export enum AuthAccountType {
  Email = 'Email',
  Google = 'Google',
  SMS = 'SMS',
  Apple = 'Apple',
}
